<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import Slider from '@martyrs/src/design-system/components/Slider/Slider.vue'

const { tm } = useI18n({
  useScope: 'global'
})
const features = computed(() => tm('auth.features'))
</script>

<template>
  <!-- Чистый текстовый слайдер. Фон (шейдер) живёт на уровне layout Auth.vue —
       здесь только слайды поверх него. -->
  <Slider :showDots="true" :slideCount="features.length" class="auth_slider h-100">
    <div
      class="carousel__slide d-flex flex-column flex-center h-100 pd-big t-center"
      v-for="(feature, index) in features"
      :key="index"
    >
      <h4 class="t-inverse w-100 mn-b-small">{{ feature.title }}</h4>
      <p class="t-inverse opacity-80 w-100 w-max-30r mn-l-auto mn-r-auto">{{ feature.description }}</p>
    </div>
  </Slider>
</template>

<style lang="scss">
.auth_slider .carousel,
.auth_slider .carousel__container {
  height: 100%;
}
</style>
